import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";
import axios from 'axios'
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import { useGlobalContext } from "../../../../../../context";
import Cookies from "universal-cookie";
import swal from "sweetalert";
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

function BasicInfo({getCurrentReportDataAfterUpdate,object,Access,advanceSearch,section_id,stage_transaction_type_id,setRenderCheck,renderCheck}) {
    const [folderNumber,setFolderNumber]=useState(object?.folder_number)
    const [gender,setGender]=useState(object?.gender)
    const [taxPayerName,setTaxPayerName]=useState(object?.tax_payer_name)
    const [motherName,setMotherName]=useState(object?.mother_name)
    const [nationality,setNationality]=useState(object?.nationality)
    // Normalize potentially string dates to Date | null
    const normalizeDate = (d) => {
        if (!d) return null;
        if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
        if (typeof d === 'string') {
            const iso = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (iso) {
                const y = Number(iso[1]), m = Number(iso[2]) - 1, day = Number(iso[3]);
                const date = new Date(y, m, day);
                return isNaN(date.getTime()) ? null : date;
            }
            const slash = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (slash) {
                const day = Number(slash[1]), m = Number(slash[2]) - 1, y = Number(slash[3]);
                const date = new Date(y, m, day);
                return isNaN(date.getTime()) ? null : date;
            }
            const parsed = new Date(d);
            return isNaN(parsed.getTime()) ? null : parsed;
        }
        return null;
    }
    const [birthDate,setBirthDate]=useState(normalizeDate(object?.birth_date))
    const [loading,setLoading]=useState(false)
    // const [AccessView,setAccessView]=useState(false);
    // const [AccessAdd,setAccessAdd]=useState(false);
    // const [AccessUpdate,setAccessUpdate]=useState(false);
    // const [AccessVoid,setAccessVoid]=useState(false);
    const {
        fetchData,
      } = useGlobalContext();

    useEffect(()=>{
        // if(Access?.length>0)
        console.log(Access);
    },[Access])
    const checkAccessPrivileges =()=>{
        console.log('h1',Access)
        let check=true;
        Access?.map((data)=>{
          console.log('h2',data)

            if(data==1){
             console.log('h3')

                check=true;
            }
            if(data==2||data==3||data==4){
             console.log('h4')

                check=false
            }
        })
        return check;
    }

    const checkAccessPrivilegesCanView=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==1){
                check=true;
            }else if(data==2||data==3||data==4){
                check=false
            }
        })
        return check;
    }

    const checkAccessPrivilegesCanEdit=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==3){
                check=true;
             }
        })
        return check;
    }
    const checkAccessPrivilegesCanAdd=()=>{
        let check=false;
        Access?.map((data)=>{
            if(data==2){
                check=true;
             }
        })
        return check;
    }
    
     //============format date to format yyyy-mm-dd============
    const formatDate = (date) => {
        let y = date.getFullYear();

        let m = date.getMonth() + 1;
        if (m < 10) m = "0" + m;

        let d = date.getDate();
        if (d < 10) d = "0" + d;

        return y + "-" + m + "-" + d;
    };
    const updateData=async()=>{
        let data=null;
        setLoading(true);
        try{
            data=await axios({
               method: 'put',
               url:ApiSetting.apiUrl+'/income_tax_report/'+object?.id,
               data:{
                section_name:'1',
                folder_number:folderNumber,
                gender:gender,
                tax_payer_name:taxPayerName,
                mother_name:motherName,
                nationality:nationality,
                birth_date: birthDate ? formatDate(birthDate) : null,
                user_id:cookies.get('user_id'),
                role_id:cookies.get('role_id')+1,
                section_id:section_id,
                stage_transaction_type_id:stage_transaction_type_id

               },
               headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-localization": language,
               }
            })
            if(data){
                if(data?.data?.status==200){
                    swal("تم التحديث!", `${data?.data?.message}`, "success");
                    setFolderNumber(data?.data?.data?.folder_number);
                    setGender(data?.data?.data?.gender);
                    setTaxPayerName(data?.data?.data?.tax_payer_name);
                    setMotherName(data?.data?.data?.mother_name);
                    setNationality(data?.data?.data?.nationality);
                    setBirthDate(normalizeDate(data?.data?.data?.birth_date));
                    getCurrentReportDataAfterUpdate()
                    
                }else if(data?.data?.status==505){
                    let message=null;
                    if(data?.data?.data?.user_id){
                        data?.data?.data?.user_id?.map((mes)=>{
                            message+=mes+'\n';
                        })
                    }
                }
            }
        }catch(err){
            swal("فشل التحديث!", `${err?.message}`, "error");
            setLoading(false);

        }
        
    }
   
    return (
        <>
            {/*###==> basic information here ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    marginTop: "10px",
                    color: "#5f7b8a",
                }}
            >
                المعلومات الاساسية
            </h4>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "row wrap",

                    border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: 10,
                    paddingBottom: 10,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            label="رقم الضبارة"
                            variant="outlined"

                            value={folderNumber}
                            onChange={(e) => {
                                setFolderNumber(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.folderNumber) {
                            return err.folderNumber;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingLeft: 10,
                        paddingTop: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="career-simple-select-label">
                            الجنس
                        </InputLabel>
                        <Select
                            disabled={checkAccessPrivileges()}
                            labelId="career-simple-select-label"
                            id="career-simple-select"
                            value={gender}
                            label="الجنس "
                            onChange={(e) => {
                                setGender(e.target.value);
                            }}
                        >
                            <MenuItem value={0}>{"ذكر"}</MenuItem>
                            <MenuItem value={1}>{"انثى"}</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.gender) {
                            return err.gender;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="الاسم الكامل"
                            variant="outlined"
                            value={taxPayerName}
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            onChange={(e) => {
                                setTaxPayerName(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.taxPayerName) {
                            return "الاسم الاول مطلوب";
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <TextField
                            label="اسم الام"
                            variant="outlined"
                            value={motherName}
                            InputProps={{
                                readOnly: checkAccessPrivileges(),
                            }}
                            onChange={(e) => {
                                setMotherName(e.target.value);
                            }}
                        />
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.motherName) {
                            return err.motherName;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="calculation-type-simple-select-label">
                            الجنسية
                        </InputLabel>
                        <Select
                            disabled={checkAccessPrivileges()}
                            labelId="calculation-type-simple-select-label"
                            id="calculation-type-simple-select"
                            // value={selectedCalculationType}
                            label="الجنسية "
                            value={nationality}
                            onChange={(e) => {
                                setNationality(e.target.value);
                            }}
                        >
                            <MenuItem value={"عراقية"}>عراقية</MenuItem>
                            <MenuItem value={"عربية"}>عربية</MenuItem>
                            <MenuItem value={"اجنبية"}>اجنبية</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.nationality) {
                            return err.nationality;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

                <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="التولد"
                                inputFormat="dd/MM/yyyy"
                                disabled={checkAccessPrivileges()}
                                value={normalizeDate(birthDate)}
                                onChange={(date) => {
                                    setBirthDate(date);
                                }}
                                renderInput={(params) => <TextField InputProps={{ readOnly: true }} {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <Typography className="fontForError">
                        {/* {messageErrors.length > 0
                      ? messageErrors.map((err) => {
                          if (err.birthDate) {
                            return err.birthDate;
                          }
                        })
                      : null} */}
                    </Typography>
                </div>

              
            </div>
               
               {
                checkAccessPrivilegesCanEdit()||checkAccessPrivilegesCanAdd()?
               <div
                    style={{
                        display: "flex",
                        width:'100%',
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                     <Button variant="contained" style={{backgroundColor:"#5f7b8a",paddingLeft:30,paddingRight:30}}
                       onClick={()=>{
                         updateData();
                       }}
                      >
                            {!loading ? (
                            "تحديث"
                        ) : (
                            <div class="spinner-border " role="status">
                            <span class="visually-hidden">Loading...</span>
                            </div>
                        )}
                     </Button>
               </div>:null
              }
        </>
    )
   
   
}

export default BasicInfo